import { GET_REPORT_DATA } from './mutation-types'
import relatorioDisponibilidadeHttpService from '../_services/relatorioDisponibilidadeHttpService'

export default {
  gerarRelatorio: async ({ commit }, form) => {
    const [responseDadosGerais, responseDiasCorridos] = await Promise.all([
      relatorioDisponibilidadeHttpService.postRelatorioDisponibilidadeResumidoInformacaoGeral(form),
      relatorioDisponibilidadeHttpService.postRelatorioDisponibilidadeResumidoInformacaoDiaCorrido(form),
    ])

    let responseReport = []

    for (let i = 0; i < responseDadosGerais.data.length; i++) {
      responseReport.push(Object.assign({}, responseDadosGerais.data[i], { horasPorDia: responseDiasCorridos.data[i] }))
    }
    commit(GET_REPORT_DATA, responseReport)
    
  },
}
